// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'copy';

export const Component = () => (
  <path d='M22.6 5.927h-3.928v-2.92c0-.24-.096-.48-.288-.72a.946.946 0 0 0-.67-.287H2.005a.946.946 0 0 0-.67.288c-.239.239-.335.478-.335.718V17.71c0 .24.096.48.335.67.192.24.431.336.67.336h2.922v3.927c0 .24.096.48.335.67a.946.946 0 0 0 .67.288h16.666c.24 0 .48-.096.72-.288a.946.946 0 0 0 .287-.67V6.934c0-.24-.096-.48-.288-.72-.239-.19-.479-.287-.719-.287h.001ZM2.004 17.71V3.005h15.708V17.71H2.005ZM22.599 6.933V22.64H5.933v-3.927h11.781c.24 0 .479-.096.67-.335a.946.946 0 0 0 .288-.67V6.933h3.927Z' />
);

export const viewBox = '0 0 25 25';
